import { z } from 'zod'

/** Provenance travels with a scene even when its library download is removed. */
export const SceneAssetSchema = z.object({
  id: z.string().min(1), title: z.string().min(1), author: z.string().optional(),
  license: z.object({ name: z.string(), url: z.string().optional(), commercial: z.boolean().optional() }).optional(),
})
const sceneFile = z.string().regex(/^\/outputs\/[\w.-]+$/, 'Expected a scene-owned output file')
export const SceneEnvironmentSchema = SceneAssetSchema.extend({
  file: sceneFile, intensity: z.number().min(0).max(5).default(1), background: z.boolean().default(true),
})
export const SceneMaterialSchema = SceneAssetSchema.extend({
  maps: z.object({ color: sceneFile.optional(), normal: sceneFile.optional(), roughness: sceneFile.optional(), metalness: sceneFile.optional(), ao: sceneFile.optional() }),
  repeat: z.number().min(0.1).max(20).default(1),
})
export const SceneLibrarySettingsSchema = z.object({
  environment: SceneEnvironmentSchema.nullable().optional(),
  material: SceneMaterialSchema.nullable().optional(),
})
export const ApplyLibraryAssetSchema = z.object({ assetId: z.string().min(1) })
export const ShapeOptionsSchema = z.object({
  shape: z.enum(['box', 'sphere', 'torus', 'knot', 'cylinder', 'cone', 'capsule', 'icosahedron']),
  size: z.number().min(0.1).max(10).default(1),
  detail: z.number().int().min(8).max(64).default(32),
  twist: z.number().min(-180).max(180).default(0),
  color: z.string().regex(/^#[0-9a-f]{6}$/i).default('#b8b8b8'),
  metalness: z.number().min(0).max(1).default(0.1),
  roughness: z.number().min(0).max(1).default(0.35),
})
export type SceneLibrarySettings = z.infer<typeof SceneLibrarySettingsSchema>
export type ShapeOptions = z.infer<typeof ShapeOptionsSchema>
